import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { WalletService } from '../services/wallet.service';

// Admin wallet addresses — move to environment/config in production
const ADMIN_ADDRESSES: string[] = [];

export const adminGuard: CanActivateFn = () => {
  const walletService = inject(WalletService);
  const router = inject(Router);

  const address = walletService.address();
  if (address && ADMIN_ADDRESSES.includes(address.toLowerCase())) {
    return true;
  }

  return router.createUrlTree(['/market']);
};
